<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>검색조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th star>대학</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="searchedCollegeName"/>&nbsp;
                  <button v-focus @click="() => { this.isShowCollegeModal = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th star>학과</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="searchedClassName" />
                  <button @click="() => {this.isShowClassModal = true;}">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th star>졸업년월</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="query.graduationYm" v-on:keyup.enter="searchQuery" placeholder="YYYY-MM" v-mask="'####-##'">
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
        </md-card-actions>
      </md-card>

      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="executivesGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>


        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div>
            <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]" >
              <md-icon>get_app</md-icon>
              Excel 다운로드
            </md-button>
          </div>

          <div>
            <input type="text" class="w120" placeholder="졸업회수" v-model="query.graduationNo">
            <md-button class="md-info md-sm" @click="bundleUpdate" :disabled="(String(this.query.graduationNo).trim().length === 0) || this.pagination.total === 0">
              <md-icon>sync_alt</md-icon>일괄 업데이트
            </md-button>
          </div>
        </md-card-actions>
      </md-card>
    </div>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--대학선택 팝업 -->
      <college-search-pop-comp :is-show.sync="isShowCollegeModal" @returnResult="callbackCollege"></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp :is-show.sync="isShowClassModal" :m-code-cd.sync="query.collegeCd" @returnResult="callbackClass"></class-search-pop-comp>

    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->

  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import { CollegeSearchPopComp, ClassSearchPopComp } from "@/pages"
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  components: {
    grid: Grid,
    CollegeSearchPopComp,
    ClassSearchPopComp
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  created() {
    this.initGrid();
  },

  data(){
    return{
      formatter,

      // 대학 선택 데이터
      searchedCollegeName: "",
      isShowCollegeModal: false,

      // 학과 선택 데이터
      searchedClassName: "",
      isShowClassModal: false,

      currentSort: "name",
      currentSortOrder: "asc",

      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      propsToSearch: ["name", "email", "age"],
      query: {
        collegeCd : "",
        classCd : "",
        graduationYm : "",
        graduationNo : ""
      },
      enterYear: "",
      enterMonth: "",
      graduationYear: "",
      graduationMonth: "",
      isCheckedHomeZipcd: false
    };
  },

  methods: {
    bundleUpdate(){
      if(!this.query.graduationNo)  {
        kuaaFnc.showSwal("졸업회수 관리", '업데이트할 졸업회수를 입력하세요');
        return false;
      }
      kuaaApi.sendServer(
          URL_CONST.UPDATE_GRADUATION_NO,
          this.query,
          "post",
          response => {
            if (response.data.success){
              kuaaFnc.showSwal("졸업회수 관리", '일괄 저장 되었습니다.');
              this.searchQuery();
            } else {
              kuaaFnc.showSwal("졸업회수 관리", response.data.resultMessage);
            }
          }
      );
    },

    /**
     * 검색 조건 초기화
     */
    clearQuery() {
      this.query = {
        collegeCd : "",
        classCd : "",
        graduationYm : "",
        graduationNo: ""
      };
      this.searchedCollegeName = "";
      this.searchedClassName = "";
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    searchQuery() {
      if(!this.query.collegeCd || this.query.collegeCd == ''){
        Swal.fire("대학을 선택하세요");
        return;
      }
      if(!this.query.classCd || this.query.classCd == ''){
        Swal.fire("학과를 선택하세요");
        return;
      }
      if(!this.query.graduationYm || this.query.graduationYm.replace('-', '').length != 6){
        Swal.fire("졸업년월을 정확히 입력하세요");
        return;
      }

      this.query = {
        collegeCd : this.query.collegeCd,
        classCd : this.query.classCd,
        graduationYm : kuaaFnc.parseYm(this.query.graduationYm)
      }

      this.$refs.executivesGrid.invoke("readData", 1, this.query);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo', sortable: true},
          {header: '교우명', name: 'memberHnm', sortable: true},
          {header: '성별', name: 'sex', align:"center", sortable: true},
          {header: '생년월일', name: 'birthday', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '대학명', name: 'collegeCdNm', align:"center", sortable: true},
          {header: '학과명', name: 'classCdNm', sortable: true},
          {header: '졸업회수', name: 'graduationNo', align:"center", sortable: true},
          {header: '입학년월', name: 'enterYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '졸업년월', name: 'graduationYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '학번', name: 'hakbun', align:"center", sortable: true}
        ];
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"졸업회수 관리 조회");
      }
    },

    /**
     * 대학 검색
     */
    callbackCollege(result) {
      this.searchedCollegeName = result.codeNm;
      this.query.collegeCd = result.code;
      if(this.query.classCd){
        this.searchedClassName = "";
        this.query.classCd = "";
      }
    },

    /**
     * 학과 검색
     */
    callbackClass(result) {
      this.searchedClassName = result.codeNm;
      this.query.classCd = result.code;
      this.searchedCollegeName = result.mCodeNm;
      this.query.collegeCd = result.mCodeCd;
    },

    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '졸업회수관리';
      kuaaApi.requestFileDownload(
          URL_CONST.MEMBER_EXCEL_DOWNLOAD,
          this.query,
          '졸업회수관리.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style>

</style>